import { render, staticRenderFns } from "./CensusApproval.vue?vue&type=template&id=cbdf1f6e&"
import script from "./CensusApproval.vue?vue&type=script&lang=js&"
export * from "./CensusApproval.vue?vue&type=script&lang=js&"
import style0 from "./CensusApproval.vue?vue&type=style&index=0&id=cbdf1f6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports